// 拿到封装好的网络请求工具包
import request from '../utils/request'
// 获取指标接口
export const calculate = params => request({
  url: '/api/classify/calculate',
  params,
  headers: { 'Token-Circus': window.localStorage.getItem("Token-Circus"), 'Unique-Ident': window.localStorage.getItem("umtId") }
})
